import { poe1 } from "../../game";
import { FORCE_FIXED_ECO as FORCE_FIXED_ECO } from "../const";
import { Economy } from "./economy-models";
import { AbyssJewelsCategory, ArmourType, AttackWeaponsCategory, BaseTypeTier, CasterWeaponsCategory, GearBaseTypeMode, GearSizeType, Color, Comparator, TieringMode, DefenceType, DisplayType, EldritchItemType, EnergyShieldArmourCategory, EquipmentTieringMode, GemWeaponsCategory, JewelleryCategory, JewelsCategory, LifeArmourCategory, MapType, MinimapIconShape, MinimapIconSize, ModItemCategoryType, QuiversCategory, Rarity, SkillGemFilterType, SocketedItemType, EquipmentTierType, WaystoneFilterType, WeaponType, YesNoAny, JewelleryType, JewelType, VendoringGearType, LabelSize, DefaultLabelSize, TimeLostJewelsCategory, EndgameContent } from "./enums";
import { ChanceBaseTierType, ClusterJewelTierValueList, CustomTieredChanceBase, CustomTieredEquipment, CustomTieredGear, CustomTieredJewellery, CustomTieredItem, TieredMod, CustomTieredUnique, Tier, TierValueList, UniqueTierType, CustomModItemCategory, EquipmentSlotType, UniquesTierValueList } from "./item-data-models";
import { RuleId } from "./rule-id";
import { SimulatorResult } from "./simulator-models";
import { defaultFavouriteBasicCurrencyTypes as defaultFavouriteBasicCurrencyTypesPoE1 } from "../data/poe1/item-lists";
import { defaultFavouriteBasicCurrencyTypes as defaultFavouriteBasicCurrencyTypesPoE2 } from "../data/poe2/item-lists";

export type filterGroup = 'levelingFilters' | 'vendorRecipeFiltersPoe1' | 'salvagingGearFiltersPoe2'
  | 'remainingFlaskCharmFilters' | 'favouriteCurrencyFilters' | 'currencyFilters'
  | 'unidentifiedEquipmentFiltersPoe2' | 'influencedGearFiltersPoe1' | 'influencedJewelleryFiltersPoe1'
  | 'identifiedItemFilters' | 'craftingBaseFiltersPoe1' | 'craftingBaseFiltersPoe2'
  | 'specialUniqueFilters' | 'remainingGearFilters' | 'remainingJewelleryFilters'
  | 'gemFiltersPoe1' | 'mapFiltersPoe1' | 'otherItemFilters' | 'specialEquipmentFiltersPoe2';

export type filterSection = 'leagueStart' | 'currency' | 'uniques' | 'other' | 'myEquipment' | 'otherEquipment' | 'remainingEquipment';

export class Filter {
  static sections: {
    group: filterGroup,
    section: filterSection,
    rules: {
      key: keyof Filter,
      poe1?: boolean,
      poe2?: boolean,
    }[]
  }[] = [
    // League Start
    { group: 'levelingFilters', section: 'leagueStart', rules: [
{ key: 'showLevelingGear' },
{ key: 'showLevelingGearWeapons' },
{ key: 'showLevelingGearArmour' },
{ key: 'showLevelingFlasks' },
{ key: 'showLevelingGold' },
{ key: 'showLevelingVerisium', poe2: true },
    ] },
    { group: 'vendorRecipeFiltersPoe1', section: 'leagueStart', rules: [
{ key: 'showVendoringRares', poe1: true },
{ key: 'showVendoringMagics', poe1: true },
{ key: 'showChaosRecipe', poe1: true },
{ key: 'showExaltRecipe', poe1: true },
{ key: 'showJewellersRecipe', poe1: true },
{ key: 'showChromaticRecipe', poe1: true },
{ key: 'showQualityWeapons', poe1: true },
{ key: 'showQualityArmour' },
{ key: 'showQualityFlasks' },
    ] },
    { group: 'salvagingGearFiltersPoe2', section: 'leagueStart', rules: [
{ key: 'showVendoringRares', poe2: true },
{ key: 'showVendoringMagics', poe2: true },
{ key: 'showSocketedGear', poe2: true },
{ key: 'showQualityMartialWeapons', poe2: true },
{ key: 'showQualityCasterWeapons', poe2: true },
{ key: 'showQualityArmour' },
{ key: 'showQualityFlasks' },
{ key: 'showQualityCharms', poe2: true },
    ] },
    // Currency
    { group: 'favouriteCurrencyFilters', section: 'currency', rules: [
{ key: 'favouriteBasicCurrency' },
{ key: 'favouriteScarabs', poe1: true },
    ] },
    { group: 'currencyFilters', section: 'currency', rules: [
{ key: 'hideScrolls' },
{ key: 'hidePortalScrolls', poe1: true },
{ key: 'hideGold' },
{ key: 'showLargeGoldStacks' },
{ key: 'showHugeGoldStacks' },
{ key: 'hideVerisium', poe2: true },
{ key: 'showLargeVerisiumStacks', poe2: true },
{ key: 'showHugeVerisiumStacks', poe2: true },
{ key: 'hideRegularRunes', poe2: true },
{ key: 'hideCurrency' },
{ key: 'hideUncutGems', poe2: true },
{ key: 'stackedGeneralCurrencyPromotionEnabled' },
{ key: 'stackedGeneralCurrencyNeverPromote' },
{ key: 'promoteForcedHiddenCurrency' },
{ key: 'promoteForcedHiddenCurrencyOneTierStackSize' },
{ key: 'promoteForcedHiddenCurrencyTwoTiersStackSize' },
    ] },
    // Uniques
    { group: 'specialUniqueFilters', section: 'uniques', rules: [
{ key: 'showExceptionalUniques', poe2: true },
{ key: 'showVaalUniques', poe2: true },
{ key: 'showVaalModUniques', poe2: true },
{ key: 'showFoulbornUniques', poe1: true },
{ key: 'showUniqueMaps', poe1: true },
{ key: 'showHighDustValueUniques', poe1: true },
    ] },
    // Other Items
    { group: 'gemFiltersPoe1', section: 'other', rules: [
{ key: 'showTopTierAwakenedGems', poe1: true },
{ key: 'showTopTierSpecialSupportGems', poe1: true },
{ key: 'showTopTierExceptionalSupportGems', poe1: true },
{ key: 'showOtherExceptionalSupportGems', poe1: true },
{ key: 'showImbuedGems', poe1: true },
{ key: 'showLvl21Quality20Gems', poe1: true },
{ key: 'showLvl20Quality20Gems', poe1: true },
{ key: 'showLvl21Gems', poe1: true },
{ key: 'showLevelGems', poe1: true },
{ key: 'showQuality23Gems', poe1: true },
{ key: 'showQualityGems', poe1: true },
{ key: 'showOtherQualityGems', poe1: true },
{ key: 'showSearchedGems', poe1: true },
{ key: 'hideOtherGems', poe1: true },
{ key: 'hideOtherGemsExceptVaalGems', poe1: true },
    ] },
    { group: 'mapFiltersPoe1', section: 'other', rules: [
{ key: 'dynamicWaystones', poe1: true },
    ] },
    { group: 'otherItemFilters', section: 'other', rules: [
{ key: 'showTrialItems' },
{ key: 'showTrialKeys', poe2: true },
{ key: 'hideOtherTrialItems' },
{ key: 'showQuestItems' },
{ key: 'showHeistEnchantedBlueprints', poe1: true },
{ key: 'showHeistEnchantedContracts', poe1: true },
{ key: 'showHeistBlueprints', poe1: true },
{ key: 'showHeistContracts', poe1: true },
{ key: 'showRoguesMarkers', poe1: true },
{ key: 'showRareWaystones', poe2: true },
{ key: 'showOtherWaystones', poe2: true },
    ] },
    // Other Equipment
    { group: 'unidentifiedEquipmentFiltersPoe2', section: 'otherEquipment', rules: [
{ key: 'showTieredRareGear', poe2: true },
{ key: 'showTieredMagicGear', poe2: true },
{ key: 'showTieredRareJewellery', poe2: true },
{ key: 'showTieredMagicJewellery', poe2: true },
    ] },
    { group: 'influencedGearFiltersPoe1', section: 'otherEquipment', rules: [
{ key: 'showInfluencedGear', poe1: true },
{ key: 'showFracturedGear', poe1: true },
{ key: 'showVeiledGear', poe1: true },
{ key: 'showMemoryStrandGear', poe1: true },
    ] },
    { group: 'influencedJewelleryFiltersPoe1', section: 'otherEquipment', rules: [
{ key: 'showInfluencedJewellery', poe1: true },
{ key: 'showFracturedJewellery', poe1: true },
{ key: 'showVeiledJewellery', poe1: true },
{ key: 'showMemoryStrandJewellery', poe1: true },
{ key: 'showAnointedAmulets', poe1: true },
{ key: 'showCorruptedImplicitJewels', poe1: true },
{ key: 'showCorruptedImplicitJewellery', poe1: true },
{ key: 'showExcellentClusterJewelBases', poe1: true },
{ key: 'showGoodClusterJewelBases', poe1: true },
    ] },
    { group: 'specialEquipmentFiltersPoe2', section: 'otherEquipment', rules: [
{ key: 'showAnointedAmulets', poe2: true },
{ key: 'showSpecialGear', poe2: true },
{ key: 'showExcellentSpecialJewelleryBaseTypes', poe2: true },
{ key: 'showGoodSpecialJewelleryBaseTypes', poe2: true },
{ key: 'showOtherSpecialJewelleryBaseTypes', poe2: true },
    ] },
    { group: 'identifiedItemFilters', section: 'otherEquipment', rules: [
{ key: 'showAllIdentifiedItems', poe2: true },
{ key: 'showIdentifiedGear' },
{ key: 'showIdentifiedJewellery' },
{ key: 'showIdentifiedJewels' },
{ key: 'showIdentifiedCustomItems' },
{ key: 'hideRemainingIdentifiedItems' },
{ key: 'hideRemainingIdentifiedItemsIncludingCorrupted' },
{ key: 'showRestrictedModIdentifiedItems', poe1: true },
    ] },
    { group: 'craftingBaseFiltersPoe1', section: 'otherEquipment', rules: [
{ key: 'showExcellentWeaponCraftingBases', poe1: true },
{ key: 'showGoodWeaponCraftingBases', poe1: true },
{ key: 'showExcellentArmourCraftingBases', poe1: true },
{ key: 'showGoodArmourCraftingBases', poe1: true },
{ key: 'showExcellentGearBaseTypes', poe1: true },
{ key: 'showGoodGearBaseTypes', poe1: true },
{ key: 'show6LinkedGear', poe1: true },
{ key: 'show5LinkedGear', poe1: true },
{ key: 'show6ColourGear', poe1: true },
{ key: 'show5ColourGear', poe1: true },
{ key: 'show4ColourGear', poe1: true },
{ key: 'showExcellentJewelleryBaseTypes' },
{ key: 'showGoodJewelleryBaseTypes' },
{ key: 'showExcellentQualityFlasks', poe1: true },
{ key: 'showGoodQualityFlasks', poe1: true },
{ key: 'showHighILevelFlasks', poe1: true },
    ] },
    { group: 'craftingBaseFiltersPoe2', section: 'otherEquipment', rules: [
{ key: 'showExcellentExceptionalSocketedGear', poe2: true },
{ key: 'showGoodExceptionalSocketedGear', poe2: true },
{ key: 'showExcellentExceptionalQualityGear', poe2: true },
{ key: 'showGoodExceptionalQualityGear', poe2: true },
{ key: 'showILevel82NormalGear', poe2: true },
{ key: 'showILevel81NormalGear', poe2: true },
{ key: 'showHighILevelCharms', poe2: true },
{ key: 'showExcellentJewelleryBaseTypes', poe2: true },
{ key: 'showGoodJewelleryBaseTypes', poe2: true },
    ] },
    // Remaining Equipment
    { group: 'remainingGearFilters', section: 'remainingEquipment', rules: [
{ key: 'hideAllOtherGear' },
    ] },
    { group: 'remainingJewelleryFilters', section: 'remainingEquipment', rules: [
{ key: 'hideRings' },
{ key: 'hideAmulets' },
{ key: 'hideTalismans', poe1: true },
{ key: 'hideBelts' },
{ key: 'hideJewels' },
    ] },
    { group: 'remainingFlaskCharmFilters', section: 'remainingEquipment', rules: [
{ key: 'hideLifeFlasks' },
{ key: 'hideManaFlasks' },
{ key: 'hideHybridFlasks', poe1: true },
{ key: 'hideUtilityFlasks', poe1: true },
{ key: 'hideTinctures', poe1: true },
{ key: 'hideCharms', poe2: true },
    ] },
  ];

  // ******************************************************
  // League Start
  // ******************************************************

  // Leveling Items
  showLevelingGear = true;
  showLevelingGearMinAreaLevel: number | null = null;
  showLevelingGearMaxAreaLevel: number | null = 70;

  showLevelingGearExcellentSocketed = true; // POE1
  showLevelingGearExcellentSocketedDifference: number | null = 30; // POE1
  showLevelingGearOtherSocketed= true; // POE1
  showLevelingGearOtherSocketedLevelDifference: number | null = 10; // POE1

  showLevelingGearNormal = true;
  showLevelingGearNormalLevelDifference = 5;

  showLevelingGearMagic = true;
  showLevelingGearMagicLevelDifference = poe1 ? 5 : 10;

  showLevelingGearRare = true;
  showLevelingGearRareLevelDifference = 20;

  showLevelingGearIgnoreLevelDifferenceForSpecialWeaponTypes = true; // POE2

  showLevelingGearWeapons = true;
  showLevelingGearWeaponClasses = ['All'];

  showLevelingGearArmour = true;
  showLevelingGearArmourDefenceTypes = ['All'];

  showLevelingGearAllMagicRareBoots = true;
  showLevelingGearAllMagicRareBootsMaxAreaLevel = 20;

  showLevelingFlasks = true;
  showLevelingFlasksAlwaysHideHybrid = true;

  showLevelingGold = true;
  showLevelingVerisium = true;

  // Vendoring items

  showVendoringRares = true;
  showVendoringRaresSize = GearSizeType.All;
  showVendoringRaresUntilAreaLevel = 40;

  showVendoringMagics = poe1 ? false: true;
  showVendoringMagicsSize = GearSizeType.TwoByTwoOnly;
  showVendoringMagicsUntilAreaLevel = 20;

  showVendoringRaresType = VendoringGearType.ShowStyled;

  // POE1 Vendoring recipes

  showChaosRecipe = false;
  showChaosRecipeTarget = ['All'];
  showExaltRecipe = false;
  showExaltRecipeTarget = ['All'];
  showExaltRecipeInfluence = ['All'];

  showJewellersRecipe = true;
  showChromaticRecipe = true;
  showChromaticRecipeType = GearSizeType.TwoByTwoOnly;

  showQualityWeapons = true;
  showQualityWeaponsMinQuality = 1;
  showQualityWeaponsSize = GearSizeType.All;

  // POE2 Salvaging Gear
  showSocketedGear = true;
  showSocketedGearType = SocketedItemType.TwoOrMoreSockets;

  showQualityMartialWeapons = true;
  showQualityMartialWeaponsMinQuality = 1;
  showQualityMartialWeaponsSize = GearSizeType.All;
  showQualityCasterWeapons = true;
  showQualityCasterWeaponsMinQuality = 1;
  showQualityCasterWeaponsSize = GearSizeType.All;

  // POE1 & 2: Quality Armour
  showQualityArmour = true;
  showQualityArmourMinQuality = 1;
  showQualityArmourSize = GearSizeType.All;

  // ******************************************************
  // Flasks & Charms
  // ******************************************************

  // Favourite Flasks
  flaskFilters: FlaskFilter[] = [];

  // Salvaging/Recipe Quality Flasks
  showQualityFlasks = true;
  showQualityFlasksMinQuality = 1;

  // POE2 Charms
  showQualityCharms = true;
  showQualityCharmsMinQuality = 1;

  // POE2 Crafting Base charms
  showHighILevelCharms = true;
  showHighILevelCharmsMinILevel = 82;
  showHighILevelCharmTypes = ['Thawing Charm', 'Silver Charm', 'Golden Charm', 'Staunching Charm', 'Stone Charm'];

  // POE1 Crafting Base Flasks
  showHighILevelFlasks = false;
  showHighILevelFlasksMinILevel = 84;
  showHighILevelFlaskTypes = ['All'];

  // POE1 Quality Flasks

  showExcellentQualityFlasks = true;
  showExcellentQualityFlasksMinQuality = 25;

  showGoodQualityFlasks = true;
  showGoodQualityFlasksMinQuality = 21;

  showQualityFlasksMinILevel: number | null = null;
  showQualityFlaskTypes = ['All'];

  // Remaining Flasks
  hideLifeFlasks = false;
  hideManaFlasks = false;
  hideHybridFlasks = false; // POE1
  hideUtilityFlasks = false; // POE1
  hideTinctures = false; // POE1
  hideCharms = false; // POE2

  // ******************************************************
  // Currency
  // ******************************************************

  hideScrolls = false;
  hideScrollsLowerThan: number | null = null; // POE1
  hidePortalScrolls = false; // POE1
  hidePortalScrollsLowerThan: number | null = null; // POE1

  hideGold = false;
  hideGoldLowerThan = 50;
  showLargeGoldStacks = true;
  showLargeGoldStacksMinStackSize = 500;
  showHugeGoldStacks = true;
  showHugeGoldStacksMinStackSize = 2000;

  hideVerisium = false;
  hideVerisiumLowerThan = 5;
  showLargeVerisiumStacks = true;
  showLargeVerisiumStacksMinStackSize = 50;
  showHugeVerisiumStacks = true;
  showHugeVerisiumStacksMinStackSize = 200;

  hideRegularRunes = false; // POE2
  hideRegularRunesExceptions = ['None']; // POE2

  hideCurrency = false;
  hideCurrencyTypes = ['None'];

  favouriteBasicCurrency = true;
  favouriteBasicCurrencyTypes = poe1 ? defaultFavouriteBasicCurrencyTypesPoE1 : defaultFavouriteBasicCurrencyTypesPoE2;
  favouriteBasicCurrencyMode = FavouriteCurrencyMode.Multiplier;
  favouriteBasicCurrencyValue: number | null = poe1? 1.5 : 2;

  favouriteScarabs = false;
  favouriteScarabsTypes: (EndgameContent | 'None')[] = ['None'];
  favouriteScarabsTypesFromPresets: EndgameContent[] = [];
  favouriteScarabsMode = FavouriteCurrencyMode.Multiplier;
  favouriteScarabsValue: number | null = poe1 ? 1.5 : 2;

  favouriteCurrencyTypes: FavouriteCurrencyType[] = [];

  // POE2 Uncut Gems
  hideUncutGems = false;
  hideUncutSkillGemsBelowLevel: number | null = null;
  hideUncutSpiritGemsBelowLevel: number | null = null;
  hideUncutSupportGemsBelowLevel: number | null = null;

  // ******************************************************
  // Uniques & Other Items
  // ******************************************************

  showClassSpecificUniquesForClasses: string[] = ['None'];

  // POE1
  showHighDustValueUniques = false;
  showHighDustValueUniquesMinAverage = 15000;
  showHighDustValueUniquesMinDust = 10000;
  showHighDustValueUniquesIncludeNonJewellery = true;
  showHighDustValueUniquesDiscountBySize = true;
  showFoulbornUniques = true;
  showUniqueMaps = true;

  // POE2
  showExceptionalUniques = true;
  showExceptionalUniquesMinQuality = 21;

  showSmallUniques = true;
  showSmallUniquesMaxSize = GearSizeType.JewelleryOnly;

  showVaalUniques = true;
  showVaalModUniques = true;

  hideAllRemainingUniques = false;

  // POE1 Gem highlights
  showTopTierAwakenedGems = true;
  showTopTierSpecialSupportGems = true;
  showTopTierExceptionalSupportGems = true;
  showOtherExceptionalSupportGems = true;

  showImbuedGems = true;

  showLvl21Quality20Gems = true;
  showLvl20Quality20Gems = true;

  showLvl21Gems = true;
  showLevelGems = true;
  showLevelGemsMinLevel = 18;

  showQuality23Gems = true;
  showQualityGems = true;
  showQualityGemsMinQuality = 10;
  showOtherQualityGems = true;

  showSearchedGems = true;
  showSearchedGemTypes = ['None'];

  hideOtherGems = false;
  hideOtherGemsExceptVaalGems = false;

  // Other Highlights
  showQuestItems = true;
  showTrialKeys = true;
  showTrialItems = true;
  showTrialItemTypes = ['All'];
  hideOtherTrialItems = false;

  // POE2 Waystone Highlights
  showRareWaystones = true;
  // showDeliriumWaystones = true;
  showOtherWaystones = true;

  // POE1 Other Highlights
  showHeistBlueprints = true;
  showHeistContracts = true;
  showHeistLocations = ['All'];
  showRoguesMarkers = true;

  showHeistEnchantedBlueprints = true;
  showHeistEnchantedContracts = true;

  show6LinkedGear = true;
  show5LinkedGear = false;
  show6LinkedGearMinBaseTypeTier = BaseTypeTier.Basic;
  show6LinkedGearMinItemLevel: number | null = null;
  show6ColourGear = true;
  show5ColourGear = true;
  show4ColourGear = true;
  show6ColourGearMinBaseTypeTier = BaseTypeTier.Basic;
  show6ColourGearMinItemLevel: number | null = null;

  // POE1 Map Filters
  dynamicWaystones = false;
  waystoneFilterType = WaystoneFilterType.StaticDefault;
  dynamicWaystonesLevel: number | null = null;

  // POE1 Map Type Filters
  // mapTypesLowTierInfluenced = true;
  mapTypesLowTierMemoryInfluenced = true;
  mapTypesLowTierBlighted = false;
  mapTypesLowTierDelirium = false;
  mapTypesLowTierMinTier = 14;
  mapTypesT16Normal = true;
  mapTypesT16EightMod = true;
  mapTypesT16Blighted = true;
  mapTypesT16Influenced = true;
  mapTypesT16MemoryInfluenced = true;
  mapTypesT16MemoryInfluencedCorrupted = true;
  mapTypesT16Delirium = true;
  mapTypesT17 = true;
  mapTypesT17Corrupted = true;
  mapTypesBlightRavaged = true;
  mapTypesBlightRavagedCorrupted = true;

  // ******************************************************
  // Favourite Equipment
  // ******************************************************

  weaponFilters: WeaponFilter[] = [];
  armourFilters: ArmourFilter[] = [];
  jewelleryFilters: JewelleryFilter[] = [];
  jewelFilters: JewelFilter[] = [];
  // charmFilters: CharmFilter[] = [];

  // ******************************************************
  // Other Equipment
  // ******************************************************

  // POE2 Tiered Gear Exceptions
  showTieredRareGear = true;
  showTieredRareGearMinBaseTypeTier = BaseTypeTier.Basic;
  showTieredRareGearMinTier = 3;

  showTieredMagicGear = true;
  showTieredMagicGearMinBaseTypeTier = BaseTypeTier.Basic;
  showTieredMagicGearMinTier = 4;

  showLowTierTieredRareGear = true;
  showLowTierTieredRareGearMinTier = 4;

  showLowTierTieredMagicGear = true;
  showLowTierTieredMagicGearMinTier = 5;

  // POE2 Tiered Jewellery Exceptions
  showTieredRareJewellery = true;
  showTieredRareJewelleryTypes: JewelleryType[] = [JewelleryType.All];
  showTieredRareJewelleryMinIlevel: number | null = null;
  showTieredRareJewelleryMinTier = 3;

  showTieredMagicJewellery = true;
  showTieredMagicJewelleryTypes: JewelleryType[] = [JewelleryType.All];
  showTieredMagicJewelleryMinIlevel: number | null = null;
  showTieredMagicJewelleryMinTier = 3;

  // POE1 Special Gear Exceptions
  showInfluencedGear = true;
  showInfluencedGearMinBaseTypeTier = BaseTypeTier.Elite;
  showInfluencedGearMinItemLevel: number | null = null;
  showFracturedGear = true;
  showFracturedGearMinBaseTypeTier = BaseTypeTier.Elite;
  showFracturedGearMinItemLevel: number | null = null;
  showVeiledGear = true;
  showVeiledGearMinBaseTypeTier = BaseTypeTier.Elite;
  showVeiledGearMinItemLevel: number | null = null;
  showVeiledGearOfSyndicateMembers = ['All Members'];
  showMemoryStrandGear = true;
  showMemoryStrandGearMinBaseTypeTier = BaseTypeTier.Elite;
  showMemoryStrandGearMinItemLevel: number | null = null;
  showMemoryStrandGearMinStrands = 60;

  // POE1 Jewellery Highlights
  showInfluencedJewellery = true; // POE1
  showFracturedJewellery = true; // POE1
  showVeiledJewellery = true; // POE1
  showVeiledJewelleryOfSyndicateMembers = ['All Members']; // POE1
  showMemoryStrandJewellery = true; // POE1
  showMemoryStrandJewelleryMinStrands = 60; // POE1

  showAnointedAmulets = true; // POE1

  showCorruptedImplicitJewels = true; // POE1
  showCorruptedImplicitJewelsTypes = ['All']; // POE1
  showCorruptedImplicitJewelsMinImplicits = 1; // POE1
  showCorruptedImplicitJewelsMinExplicits: number | null = 3; // POE1

  showCorruptedImplicitJewellery = true; // POE1
  showCorruptedImplicitJewelleryClasses: string[] = ['All']; // POE1
  showCorruptedImplicitJewelleryMinRarity = Rarity.Rare; // POE1
  showCorruptedImplicitJewelleryMinImplicits = 2; // POE1

  showExcellentClusterJewelBases = true; // POE1
  showGoodClusterJewelBases = true; // POE1
  showClusterJewelBasesMinItemLevel = 1; // POE1

  identifiedItemConfigs: IdentifiedItemConfig[] = createDefaultIdentifiedItemConfigs();

  showAllIdentifiedItems = false; // POE2

  showIdentifiedGear: boolean = true;
  showIdentifiedJewellery: boolean = true;
  showIdentifiedJewels: boolean = true;
  showIdentifiedCustomItems: boolean = true;

  showIdentifiedAttackWeaponCategories: AttackWeaponsCategory[] = [AttackWeaponsCategory.All];
  showIdentifiedAttackWeaponTypes: WeaponType[] = [WeaponType.All];
  showIdentifiedCasterWeaponCategories: CasterWeaponsCategory[] = [CasterWeaponsCategory.All];
  showIdentifiedGemWeaponCategories: GemWeaponsCategory[] = [GemWeaponsCategory.All]; // POE1
  showIdentifiedQuiverCategories: QuiversCategory[] = [QuiversCategory.All];
  showIdentifiedLifeArmourCategories: LifeArmourCategory[] = [LifeArmourCategory.All];
  showIdentifiedLifeArmourTypesDefenceTypes: DefenceType[] = [DefenceType.All];
  showIdentifiedEnergyShieldArmourCategories: EnergyShieldArmourCategory[] = [EnergyShieldArmourCategory.All];
  showIdentifiedEnergyShieldArmourTypesDefenceTypes: DefenceType[] = [DefenceType.ArmourEnergyShield, DefenceType.EnergyShield, DefenceType.EvasionEnergyShield];

  showIdentifiedJewelleryCategories: JewelleryCategory[] = [JewelleryCategory.All];

  showIdentifiedJewelCategories: JewelsCategory[] = [JewelsCategory.All]; // POE1
  showIdentifiedAbyssJewelCategories: AbyssJewelsCategory[] = [AbyssJewelsCategory.All]; // POE1
  showIdentifiedTimeLostJewelCategories: TimeLostJewelsCategory[] = [TimeLostJewelsCategory.All]; // POE2

  // POE1 Restricted mods
  showRestrictedModIdentifiedItems = true;
  showRestrictedModIdentifiedItemsGearTier = BaseTypeTier.Expert;
  showRestrictedModIdentifiedItemsWeaponTypes: WeaponType[] = [WeaponType.All];
  showRestrictedModIdentifiedItemsDefenceTypes: DefenceType[] = [DefenceType.All];
  showRestrictedModIdentifiedItemsDelve = true;
  showRestrictedModIdentifiedItemsIncursion = true;
  showRestrictedModIdentifiedItemsBreach = true;

  hideRemainingIdentifiedItems = true;
  hideRemainingIdentifiedItemsIncludingCorrupted = false;

  // POE2 Exceptional Gear Highlights
  showExcellentExceptionalSocketedGear = true;
  showExcellentExceptionalSocketedGearMinBaseTypeTier = BaseTypeTier.Elite;
  showGoodExceptionalSocketedGear = true;
  showGoodExceptionalSocketedGearMinBaseTypeTier = BaseTypeTier.Advanced;

  showExcellentExceptionalQualityGear = true;
  showExcellentExceptionalQualityGearMinQuality: number | null = 28;
  showExcellentExceptionalQualityGearMinBaseTypeTier = BaseTypeTier.Elite;
  showGoodExceptionalQualityGear = true;
  showGoodExceptionalQualityGearMinQuality: number | null = 24;
  showGoodExceptionalQualityGearMinBaseTypeTier = BaseTypeTier.Elite;

  // POE2 Crafting Base Highlights

  showILevel82NormalGear = true;
  showILevel82NormalGearMinBaseTypeTier = BaseTypeTier.Elite;
  showILevel81NormalGear = true;
  showILevel81NormalGearMinBaseTypeTier = BaseTypeTier.Elite;

  showSpecialGear = true;

  showExcellentSpecialJewelleryBaseTypes = true;
  showExcellentSpecialJewelleryBaseTypesMinItemLevel: number | null = null;
  showGoodSpecialJewelleryBaseTypes = true;
  showGoodSpecialJewelleryBaseTypesMinItemLevel: number | null = null;

  // POE1 Crafting Base highlights
  showWeaponCraftingBasesClasses: WeaponType[] = [WeaponType.All];
  showWeaponCraftingBasesMinItemLevel = 83;
  showExcellentWeaponCraftingBases = true; // POE1

  showGoodWeaponCraftingBases = true; // POE1

  showArmourCraftingBasesTypes: ArmourType[] = [ArmourType.All];
  showArmourCraftingBasesMinItemLevel = 83;
  showExcellentArmourCraftingBases = true; // POE1
  showGoodArmourCraftingBases = true; // POE1

  showExcellentGearBaseTypes = true; // POE1
  showExcellentGearBaseTypesMinItemLevel: number | null = 83;
  showGoodGearBaseTypes = true; // POE1
  showGoodGearBaseTypesMinItemLevel: number | null = 83;

  // Common Crafting Base highlights
  showExcellentJewelleryBaseTypes = true;
  showExcellentJewelleryBaseTypesMinItemLevel: number | null = null;
  showGoodJewelleryBaseTypes = true;
  showGoodJewelleryBaseTypesMinItemLevel: number | null = null;
  showOtherSpecialJewelleryBaseTypes = true;
  showOtherSpecialJewelleryBaseTypesMinItemLevel: number | null = null;
  showOtherSpecialJewelleryBaseTypesTypes: string[] = ['All'];

  // Overrides

  craftingBasesStyleOverride = new ItemTypeOverride({ name: 'Crafting Bases', displayOptions: {
    active: poe1 ? true : false,
    cosmeticOptions: new CosmeticOptions({ minimapIconShape: MinimapIconShape.Kite, textColor: poe1 ? "rgb(200,200,200)" : undefined })
  }});

  unidentifiedItemsStyleOverride = new ItemTypeOverride({ name: 'Unidentified Equipment', displayOptions: {
    active: false,
    cosmeticOptions: new CosmeticOptions({ minimapIconShape: MinimapIconShape.Kite })
  }});

  identifiedItemsStyleOverride = new ItemTypeOverride({ name: 'Identified Equipment', displayOptions: {
    active: false,
    cosmeticOptions: new CosmeticOptions({ minimapIconShape: MinimapIconShape.Kite })
  }});

  levelingItemsStyleOverride = new ItemTypeOverride({ name: 'Leveling Gear', displayOptions: {
    active: false,
    cosmeticOptions: new CosmeticOptions({ minimapIconShape: MinimapIconShape.Kite, fontSize: LabelSize.Larger })
  }});

  salvagingItemsStyleOverride = new ItemTypeOverride({ name: 'Salvaging Gear', displayOptions: {
    active: false,
    cosmeticOptions: new CosmeticOptions({ minimapIconShape: MinimapIconShape.Kite })
  }});

  myItemsStyleOverride = new ItemTypeOverride({ name: 'Favourite Equipment', displayOptions: {
    active: false,
    cosmeticOptions: new CosmeticOptions({ minimapIconShape: MinimapIconShape.UpsideDownHouse })
  }});

  gemStyleOverride = new ItemTypeOverride({ name: 'Gems', displayOptions: {
    active: true,
    cosmeticOptions: new CosmeticOptions({ minimapIconShape: MinimapIconShape.Circle })
  }});

  mapStyleOverride = new ItemTypeOverride({ name: poe1 ? 'Maps' : 'Waystones', displayOptions: {
    active: true,
    cosmeticOptions: new CosmeticOptions({ minimapIconShape: MinimapIconShape.Diamond })
  }});

  goldStyleOverride = new ItemTypeOverride({ name: 'Gold', displayOptions: {
    active: true,
    cosmeticOptions: new CosmeticOptions({ minimapIconShape: MinimapIconShape.Star, backgroundColor: '#000000aa' })
  }});

  verisiumStyleOverride = new ItemTypeOverride({ name: 'Verisium', displayOptions: {
    active: true,
    cosmeticOptions: new CosmeticOptions({ minimapIconShape: MinimapIconShape.Star })
  }});

  // ******************************************************
  // Remaining Equipment
  // ******************************************************

  // Remaining Gear
  hideAllOtherGear = false;

  // Remaining Jewellery
  hideRings = false;
  hideRingsOfRarity = Rarity.Normal;
  hideAmulets = false;
  hideAmuletsOfRarity = Rarity.Normal;
  hideTalismans = false; // POE1
  hideBelts = false;
  hideBeltsOfRarity = Rarity.Normal;
  hideJewels = false;
  hideJewelsOfRarity = poe1 ? Rarity.Normal : Rarity.Magic;

  // ******************************************************
  // Custom Rules
  // ******************************************************

  customRuleGroups: CustomRuleGroup[] = createDefaultCustomRuleGroups();
  customCosmeticRuleGroups: CustomRuleGroup[] = createDefaultCustomRuleGroups();
  tierCosmetics: TierCosmetic[] = createDefaultTierCosmetics();
  divCardTierCosmetics: TierCosmetic[] = createDefaultTierCosmetics();
  uniqueTierCosmetics: TierCosmetic[] = createDefaultUniqueTierCosmetics();
  chanceBaseTierCosmetics: TierCosmetic[] = createDefaultChanceBaseTierCosmetics();
  equipmentTierCosmetics: TierCosmetic[] = createDefaultEquipmentTierCosmetics();
  divCardCosmeticsSameAsTierCosmetics: boolean = false;
  divCardCosmeticsSameAsTierCosmeticsOverrides = new ItemTypeOverride({ name: 'Divination Cards', displayOptions: {
    active: false,
    cosmeticOptions: new CosmeticOptions( { minimapIconShape: MinimapIconShape.Square })
  }});
  equipmentCosmeticsSameAsTierCosmetics: boolean = false;
  equipmentCosmeticsSameAsTierCosmeticsOverrides = new ItemTypeOverride({ name: 'Equipment', displayOptions: {
    active: true,
    cosmeticOptions: new CosmeticOptions( { minimapIconShape: MinimapIconShape.Kite })
  }});

  freeRulesTop: string | null = null;
  freeRulesBottom: string | null = null;

  customCurrencyTiers: CustomTieredItem[] = [];
  customGearTiers: CustomTieredGear[] = [];
  customJewelleryTiers: CustomTieredJewellery[] = [];
  customUniqueTiers: CustomTieredUnique[] = [];
  customChanceBaseTiers: CustomTieredChanceBase[] = [];
  customModTiers: TieredMod[] = [];
  customEquipmentTiers: CustomTieredEquipment[] = [];

  customModItemCategories: CustomModItemCategory[] = [];

  customRuleStyles: CustomRuleStyle[] = createDefaultCustomRuleStyles();

  // ******************************************************
  // Special
  // ******************************************************

  // Currency stack promotion (value-aware; fixed buckets 3/5/10/20)
  stackedGeneralCurrencyPromotionEnabled = true;
  stackedCurrencyMaxPromoteSteps = 2;
  stackedGeneralCurrencyNeverPromote: string[] = ['None'];
  // Forced-hidden (Hide Currency / drag-to-F / eye-block): fixed stack promotion
  promoteForcedHiddenCurrency = false;
  promoteForcedHiddenCurrencyOneTierStackSize = poe1 ? 10 : 5;
  promoteForcedHiddenCurrencyTwoTiersStackSize = poe1 ? 20 : 10;

  // Hidden item cosmetics
  hiddenGearSmallAndTransparent = true;
  hiddenJewellerySmallAndTransparent = false;
  hiddenFlaskSmallAndTransparent = false;

  league: boolean = true;
  hardcore: boolean = false;
  ssf: boolean = false;
  ruthless: boolean = false;
  economy: Economy = FORCE_FIXED_ECO ? Economy.Fixed : Economy.League;
  tieringMode: TieringMode = 'Normal';
  tieringModeCustom: TierValueList = createDefaultCustomTierValueList();
  divCardTieringMode: TieringMode = 'Normal';
  divCardTieringModeCustom: TierValueList = createDefaultCustomTierValueList();
  uniquesTieringMode: TieringMode = 'Normal';
  uniquesTieringModeCustom: UniquesTierValueList = createDefaultCustomUniquesTierValueList();
  equipmentTieringMode: EquipmentTieringMode = 'Subtle';
  clusterJewelTieringMode: TieringMode = 'Normal'; // POE1
  clusterJewelTieringModeCustom: ClusterJewelTierValueList = createDefaultCustomClusterJewelTierValueList(); // POE1

  progressPreset: Presets | null = null;
  classPreset: string | null = null;
  cosmeticPresets: CosmeticPresets = new CosmeticPresets();
  favouriteEndgameContent: (EndgameContent | 'All')[] = ['All'];
  endgamePresetPromoteFavouriteCurrency = false;
  endgamePresetPromoteScarabs = false;
  showFavouriteRestrictedBossUniques = true;
  showFavouriteLowValueBossUniques = false;
  showOtherLowValueBossUniques = false;
  endgamePresetEnableCustomRules = true;

  // ******************************************************
  // Filter section visibility
  // ******************************************************

  sectionVisibility = {
    leagueStart: true,
    currency: true,
    uniques: true,
    other: true,
    myEquipment: true,
    otherEquipment: true,
    remainingEquipment: true,
  }

  groupVisibility = {
    showRemainingFlaskFilters: true,
    showRemainingGearFilters: true,
    showRemainingJewelleryFilters: true,
    showCurrencyGeneralSettings: true,
    showUniqueGeneralSettings: true,
    showFavouriteCurrencyFilters: true,
    showCurrencyFilters: true,
    showCurrencyStackSettings: true,
    showValuableUniquesFilters: true,
    showSpecialUniquesFilters: true,
    showRemainingUniquesFilters: true,
    showChanceBaseFilters: true,
    showGearCraftingBasesHighlights: true,
    showJewelleryCraftingBasesHighlights: true,
    showIdentifiedItemsHighlights: true,
    showIdentifiedItemConfigurations: true,
    showOtherHighlights: true,
    showJewelleryHighlights: true,
    showLevelingFilters: true, // POE1
    showVendorRecipeFiltersPoe1: true, // POE1
    showSalvagingGearFiltersPoe2: true, // POE2
    showSpecialEquipmentFiltersPoe2: true, // POE2
    showTieredGearFilters: true, // POE2
    showTieredJewelleryFilters: true, // POE2
    showExceptionalGearFilters: true, // POE2
    showInfluenceFilters: true, // POE1
    showMyWeaponFilters: true,
    showMyArmourFilters: true,
    showMyJewelleryFilters: true,
    showMyJewelFilters: true,
    showMyFlasksFilters: true,
    showDynamicFilters: true,
    showGemHighlights: true, // POE1
    showFreeTextRules: true,
  }

  // Campaign quest tracker
  completedQuests: string[] = [];

  /// ******************************************************
  /// Technical
  /// ******************************************************

  id?: string;
  migrationHistory: MigrationHistoryEntry[] = [];
}

export class FavouriteCurrencyType {
  constructor(init?: Partial<FavouriteCurrencyType>) {
    if (init) Object.assign(this, init);
  }

  enabled = true;
  fromPresets?: boolean;
  fromPresetsEndgameContent?: EndgameContent;
  itemTypes: string[] = [];
  mode = FavouriteCurrencyMode.Multiplier;
  value: number | null = poe1 ? 1.5 : 2;
}

export enum FavouriteCurrencyMode {
  Multiplier = 'Multiplier',
  PromoteTier = 'PromoteTier',
  ForceVisible = 'ForceVisible',
}

export type FilterSource = 'startup' | 'import' | 'fallback';

export interface MigrationHistoryEntry {
  source: FilterSource;
  oldVersion: string;
  newVersion: string;
  ts: string;
  success: boolean;
  errorMessage?: string;
}

export interface CustomRuleStyle {
  ruleId: RuleId;
  custom: boolean;
  partial?: boolean;
  options: CosmeticOptions;
}

export class CosmeticPresets {
  labelSize: 'default' | 'larger' | 'veryLarge' = 'larger';
  labelColor: 'default' | 'accentNeutral' | 'accentTiered' = 'accentTiered';
  startingTier: 'sTier' | 'aTier' | 'bTier' | 'cTier' = 'bTier';
  defaultLabelSize: DefaultLabelSize = 'default';
}

export class StoredFilter {
  name: string;
  filter: Filter;
  version: string;
  /** This actually contains the 'patch version'; which determines the migration; not the 'build', which is the auto-increasing number */
  build: number;
  lastUpdated: string;
  id?: string;
  /** Optional icomoon glyph name (without `icon-` prefix). When unset, UI shows auto weapon + progress icons. */
  icon?: string;
  /** True after a successful filter snapshot upload; an older snapshot may still be online after local edits. */
  snapshotUploaded?: boolean;
  /** Source filter id when this filter was imported from a share link. */
  importedFromFilterId?: string;
  /** Source filter name when this filter was imported from a share link. */
  importedFromFilterName?: string;
  /** Source username when this filter was imported from a share link that included one. */
  importedFromUsername?: string;

  constructor(name: string, filter: Filter, version: string, build: number, lastUpdated: string) {
    this.name = name;
    this.filter = filter;
    this.version = version;
    this.build = build;
    this.lastUpdated = lastUpdated;
  }
}

export class DisplayOptions {
  constructor(init?: Partial<DisplayOptions>) {
    if (init) Object.assign(this, init);

    if (init?.cosmeticOptions) {
      this.cosmeticOptions = new CosmeticOptions({ ...init?.cosmeticOptions });
    }
  }

  active? = true;
  hidden? = false;

  displayType?: DisplayType;

  displayTypeTier?: Tier;
  displayTypeTierHighlightType?: EquipmentTierType;

  cosmeticOptions?: CosmeticOptions;
}

export interface Displayable {
  displayOptions: DisplayOptions;
}

export class ItemTypeOverride implements Displayable {
  constructor(init?: Partial<ItemTypeOverride>) {
    this.displayOptions.displayType = DisplayType.ItemTypeOverrides;

    if (init) Object.assign(this, init);

    if (init?.displayOptions) {
      Object.assign(this.displayOptions, new DisplayOptions({ displayType: DisplayType.ItemTypeOverrides, ...init.displayOptions }));
    }
  }

  name?: string;

  displayOptions: DisplayOptions = new DisplayOptions();
}

export class ItemHighlight implements Displayable {
  constructor(init?: Partial<ItemHighlight>) {
    this.displayOptions.displayType = DisplayType.EquipmentTier;
    this.displayOptions.displayTypeTierHighlightType = EquipmentTierType.Item;

    if (init) Object.assign(this, init);

    if (init?.displayOptions) {
      Object.assign(this.displayOptions, new DisplayOptions({ displayType: DisplayType.EquipmentTier, displayTypeTierHighlightType: EquipmentTierType.Item, ...init.displayOptions }));
    }
  }

  displayOptions: DisplayOptions = new DisplayOptions();
}

export class TierCosmetic implements Displayable {
  constructor(init?: Partial<TierCosmetic>) {
    this.displayOptions.displayType = DisplayType.Custom;

    if (init) Object.assign(this, init);

    if (init?.displayOptions) {
      Object.assign(this.displayOptions, new DisplayOptions({ displayType: DisplayType.Custom, ...init?.displayOptions }));
    }
  }

  order: number = 0;
  tier?: Tier;
  uniqueTier?: UniqueTierType;
  chanceBaseTier?: ChanceBaseTierType;
  name?: string;
  hasChanges = false;

  displayOptions: DisplayOptions = new DisplayOptions({ cosmeticOptions: new CosmeticOptions()});
}

export class CustomRuleGroup {
  constructor(init?: Partial<CustomRuleGroup>) {
    if (init) Object.assign(this, init);
    if (init?.rules) {
      this.rules = init.rules.map(r => new CustomRule(r as Partial<CustomRule>));
    }
  }

  name = 'Default';
  isDefault = false;
  active = true;
  order = 0;
  rules: CustomRule[] = [];
}

export function createDefaultCustomRuleGroups(): CustomRuleGroup[] {
  return [new CustomRuleGroup({ name: 'Default', isDefault: true, active: true, order: 0, rules: [] })];
}

export class CustomRule implements Displayable {
  constructor(init?: Partial<CustomRule>) {
    if (init) Object.assign(this, init);

    if (init?.advancedConditions) {
      this.advancedConditions = new AdvancedConditions({ ...init?.advancedConditions });
    }

    if (init?.displayOptions) {
      Object.assign(this.displayOptions, new DisplayOptions({ ...init?.displayOptions }));
    }
  }

  order: number = 0;
  itemClass: string = 'All';
  /** Custom classes. Add double quotes. E.g. "Rings" "Amulets" */
  filterItemClass?: string = undefined;
  /** Custom base type partial match filter. Add double quotes. E.g. "Rune" */
  filterItemBaseType?: string = undefined;
  itemType: string = 'All';
  baseTypes: string[] = ['All'];
  rarityComparator: Comparator = Comparator.GreaterThanOrEqual;
  rarity: Rarity = Rarity.Normal;
  advancedConditions?: AdvancedConditions;
  continue = false;
  startWithClass?: boolean; // Technical
  label?: string;
  fromPresets?: boolean;
  fromPresetsEndgameContent?: EndgameContent;

  displayOptions: DisplayOptions = new DisplayOptions();
}

export class PreviewCustomRule extends CustomRule {
  constructor(init?: Partial<PreviewCustomRule>) {
    super(init);
    if (init) Object.assign(this, init);
  }

  ruleName?: string;
  exampleName?: string;
  influence?: string;
  fractured?: boolean;
  veiled?: boolean;
  synthesised?: boolean; // display-only (pasted / simulated items)
  sockets?: string;
  isCurrency?: boolean;
  isPoe1Gem?: boolean;
  isDivinationCard?: boolean;
  isQuestItem?: boolean;
  rareName?: string;
  isItemLibraryItem?: boolean;
  isRandomLootItem?: boolean;
  isSimulatedTierItem?: boolean;
  itemLibraryHash?: string;
  itemLibraryText?: string | null;
  librarySimulatorResult?: SimulatorResult;
  unidentifiedItemTier?: number;
  isWaystone?: boolean;
  memoryStrands?: boolean;
  stackSize?: number;
}

export class AdvancedConditions {
  constructor(init?: Partial<AdvancedConditions>) {
    if (init) Object.assign(this, init);
  }

  classes?: string;
  baseTypes?: string;
  minItemLevel?: number;
  maxItemLevel?: number;
  minDropLevel?: number;
  maxDropLevel?: number;
  minAreaLevel?: number;
  maxAreaLevel?: number;
  minGemLevel?: number;
  maxGemLevel?: number;
  minSockets?: number;
  minLinks?: number; // POE1
  socketGroup?: string; // POE1
  sockets?: string; // POE1 — Sockets condition (colours, not links)
  minQuality?: number;
  minStackSize?: number;
  minBaseDefencePercentile?: number;
  minArmour?: number;
  minEvasion?: number;
  minEnergyShield?: number;
  minWard?: number;
  waystoneMinTier?: number;
  waystoneMaxTier?: number;
  anyEnchantment?: boolean;
  unidentifiedTier?: number; // POE2
  hasInfluence?: boolean; // POE1
  influences?: string[]; // POE1
  veiled?: boolean; // POE1
  fractured?: boolean; // POE1
  transfiguredGem?: string; // POE1
  imbuedGem?: boolean; // POE1
  zanaMemory?: boolean; // POE1
  memoryStrands?: number; // POE1
  eightModMap?: boolean; // POE1
  blightedMap?: boolean; // POE1
  blightRavagedMap?: boolean; // POE1
  corrupted?: YesNoAny;
  identified?: YesNoAny;
  hasExplicitModMin?: number;
  hasExplicitMod?: string;
  corruptedImplicits?: number; // POE1
  minClusterJewelPassives?: number; // POE1
  maxClusterJewelPassives?: number; // POE1
  clusterJewelPassiveNodes?: string[] // POE1
  foulbornUnique?: boolean; // POE1
  isVaalUnique?: boolean; // POE2
  hasVaalUniqueMod?: boolean; // POE2

  static hasChanges(current?: AdvancedConditions, hidden?: boolean) {
    if (!current) {
      return 0;
    }

    return Object.keys(current).filter(key => {
      return (current[key as keyof AdvancedConditions] ?? null) !== (new AdvancedConditions()[key as keyof AdvancedConditions] ?? null);
    }).length + (hidden ? 1 : 0);
  }
}

export class CosmeticOptions {
  constructor(init?: Partial<CosmeticOptions>) {
    if (init) Object.assign(this, init);
  }

  highlight?: boolean;
  highlightColor?: Color;

  minimapIconSize?: MinimapIconSize;
  minimapIconShape?: MinimapIconShape;
  beam?: boolean;
  temp?: boolean;

  backgroundColor?: string;
  borderColor?: string;
  textColor?: string;
  fontSize?: number;

  alertSound?: boolean;
  alertSoundSound?: string;
  alertSoundVolume?: number;
  disableDropSound?: boolean;
  customAlertSound?: string;

  // Currently unused
  alertSoundPositional?: boolean;
  enableDropSound?: boolean;
  disableDropSoundIfAlertSound?: boolean;
  enableDropSoundIfAlertSound?: boolean;
}

function arraysEqual<T>(a: T[], b: T[]): boolean {
  if (a.length !== b.length) {
    return false;
  }

  // Sort both arrays to handle order-independent comparison
  const sortedA = [...a].sort();
  const sortedB = [...b].sort();

  return sortedA.every((value, index) => value === sortedB[index]);
}

export class AdvancedEquipmentConditions {
  constructor(equipmentType: EquipmentSlotType, init?: Partial<AdvancedEquipmentConditions>) {
    this.equipmentType = equipmentType;
    if (init) Object.assign(this, init);
  }

  equipmentType: EquipmentSlotType;
  fromProgressPreset?: boolean;
  fromClassPreset?: boolean;

  hasInfluence?: boolean;
  influences?: string[];
  veiled?: boolean;
  veiledOfSyndicateMembers?: string[];
  fractured?: boolean;
  minMemoryStrands?: number;
  corrupted?: YesNoAny;
  corruptedImplicits?: number;
  minQuality?: number;
  minBaseDefencePercentile?: number; // Armour only

  static excludedKeys: (keyof AdvancedEquipmentConditions)[] = ['fromClassPreset', 'fromProgressPreset'];

  static hasChanges(current?: AdvancedEquipmentConditions) {
    if (!current) {
      return 0;
    }

    const differingKeys = Object.keys(current).filter(key => !AdvancedEquipmentConditions.excludedKeys.includes(key as keyof AdvancedEquipmentConditions)).filter(key => {
      return key in new AdvancedEquipmentConditions(current.equipmentType)
        && (current[key as keyof AdvancedEquipmentConditions] ?? null) !== (new AdvancedEquipmentConditions(current.equipmentType)[key as keyof AdvancedEquipmentConditions] ?? null)
        && ![null, undefined, false].includes(current[key as keyof AdvancedEquipmentConditions] as boolean | null | undefined);
    });

    return differingKeys.length;
  }

  static equals<T extends AdvancedEquipmentConditions>(a: T, b: T, excludedProperties: (keyof T)[] = []): boolean {
    // Get all unique keys from both objects
    const allKeys = new Set([...Object.keys(a), ...Object.keys(b)]);

    const differences = Array.from(allKeys).filter(key => {
      // Skip excluded properties
      if (excludedProperties.includes(key as keyof T)) {
        return false;
      }

      const aValue = a[key as keyof T];
      const bValue = b[key as keyof T];

      if (key === 'highlightConfig') {
        return !HighlightConfig.equals(aValue as HighlightConfig, bValue as HighlightConfig);
      }

      // Handle array comparison
      if (Array.isArray(aValue) && Array.isArray(bValue)) {
        return !arraysEqual(aValue, bValue);
      }

      return aValue != bValue;
    });

    return differences.length === 0;
  }
}

export abstract class HighlightConfig {
  equipmentType: EquipmentSlotType;

  constructor(equipmentType: EquipmentSlotType) {
    this.equipmentType = equipmentType;
  }

  static equals(a?: HighlightConfig, b?: HighlightConfig): boolean {
    if (a === b) return true;
    if (!a || !b) return false;
    const keys = new Set([...Object.keys(a), ...Object.keys(b)]);
    return !Array.from(keys).some(key => {
      const av = a[key as keyof HighlightConfig];
      const bv = b[key as keyof HighlightConfig];
      if (Array.isArray(av) && Array.isArray(bv)) return !arraysEqual(av, bv);
      return av != bv;
    });
  }

  static hasChanges(current?: HighlightConfig) {
    if (!current) {
      return 0;
    }

    return Object.keys(current).filter(key => {
      if (current.equipmentType === 'gear') {
        if (!poe1 && GearHighlightConfig.poe1OnlyProperties.includes(key as keyof GearHighlightConfig)) return false;
        if (poe1 && GearHighlightConfig.poe2OnlyProperties.includes(key as keyof GearHighlightConfig)) return false;
      } else if (current.equipmentType === 'jewel') {
        if (!poe1 && JewelHighlightConfig.poe1OnlyProperties.includes(key as keyof JewelHighlightConfig)) return false;
        if (poe1 && JewelHighlightConfig.poe2OnlyProperties.includes(key as keyof JewelHighlightConfig)) return false;
      } else if (current.equipmentType === 'jewellery') {
        if (!poe1 && JewelleryHighlightConfig.poe1OnlyProperties.includes(key as keyof JewelleryHighlightConfig)) return false;
        if (poe1 && JewelleryHighlightConfig.poe2OnlyProperties.includes(key as keyof JewelleryHighlightConfig)) return false;
      }

      const value = current[key as keyof HighlightConfig];
      return typeof value === 'boolean' && value === true;
    }).length;
  }
}

export class FlaskCharmHighlightConfig extends HighlightConfig {
  constructor(charm?: boolean) {
    super('flask');
    if (charm) {
      this.qualityMin = 5;
    }
  }

  regularNormal: boolean = true;
  regularMagic: boolean = true;

  quality: boolean = true;
  qualityMin?: number = poe1 ? 21 : 15;

  iLevel: boolean = true;
  iLevelMin?: number = poe1 ? 84 : 82;
}

export class JewelHighlightConfig extends HighlightConfig {
  constructor() {
    super('jewel');
  }

  regularMagic: boolean = true;
  regularRare: boolean = true;

  // POE1
  static poe1OnlyProperties: (keyof JewelHighlightConfig)[] = ['excellentILevel', 'goodILevel'];

  excellentILevel: boolean = poe1;
  excellentILevelMin?: number = 85;
  goodILevel: boolean = poe1;
  goodILevelMin?: number = 84;

  // POE2
  static poe2OnlyProperties: (keyof JewelHighlightConfig)[] = [];
}

export class JewelleryHighlightConfig extends HighlightConfig {
  constructor() {
    super('jewellery');
  }

  regularNormal: boolean = true;
  regularMagic: boolean = true;
  regularRare: boolean = true;

  excellentILevel: boolean = true;
  excellentILevelMin?: number = poe1 ? 85 : 82;
  goodILevel: boolean = true;
  goodILevelMin?: number = poe1 ? 84 : 81;

  // POE2
  static poe2OnlyProperties: (keyof JewelleryHighlightConfig)[] = ['rare', 'magic'];

  rare: boolean = true;
  rareMinTier: number = 2;
  magic: boolean = true;
  magicMinTier: number = 3;

  // POE1
  static poe1OnlyProperties: (keyof JewelleryHighlightConfig)[] = ['excellentMemoryStrands', 'goodMemoryStrands'];

  excellentMemoryStrands: boolean = true;
  excellentMemoryStrandsMinStrands?: number = 60;
  goodMemoryStrands: boolean = true;
  goodMemoryStrandsMinStrands?: number = 20;
}

export class GearHighlightConfig extends HighlightConfig {
  constructor() {
    super('gear');
  }

  regularNormal: boolean = true;
  regularMagic: boolean = true;
  regularRare: boolean = true;

  // POE2
  static poe2OnlyProperties: (keyof GearHighlightConfig)[] = ['rare', 'magic', 'lowTierRare', 'lowTierMagic', 'excellentILevel', 'goodILevel', 'excellentExceptional', 'goodExceptional'];

  rare: boolean = true;
  rareMinTier: number = 2;
  magic: boolean = true;
  magicMinTier: number = 2;
  lowTierRare: boolean = true;
  lowTierRareMinTier: number = 3;
  lowTierMagic: boolean = true;
  lowTierMagicMinTier: number = 3;

  excellentILevel: boolean = true;
  excellentILevelMin?: number = 82;
  goodILevel: boolean = true;
  goodILevelMin?: number = 81;

  excellentExceptional: boolean = true;
  excellentExceptionalMinQuality?: number = 28;
  goodExceptional: boolean = true;
  goodExceptionalMinQuality?: number = 24;

  // POE1
  static poe1OnlyProperties: (keyof GearHighlightConfig)[] = ['excellentCraftingBase', 'goodCraftingBase', 'excellentMemoryStrands', 'goodMemoryStrands', 'sixLink', 'fiveLink', 'colouredSockets', 'colouredSocketsColours'];

  excellentCraftingBase: boolean = true;
  excellentCraftingBaseMinQuality?: number = 28;
  excellentCraftingBaseMinItemLevel?: number = 83;
  goodCraftingBase: boolean = true;
  goodCraftingBaseMinQuality?: number = 24;
  goodCraftingBaseMinItemLevel?: number = 83;

  excellentMemoryStrands: boolean = true;
  excellentMemoryStrandsMinStrands?: number = 60;
  goodMemoryStrands: boolean = true;
  goodMemoryStrandsMinStrands?: number = 20;

  sixLink: boolean = true;
  fiveLink: boolean = false;

  colouredSockets: boolean = false;
  colouredSocketsColours: string = 'RGB';
}

// export class CharmFilter extends AdvancedEquipmentConditions {
//   constructor(init?: Partial<CharmFilter>) {
//     super(init);
//     this.highlightConfig = init?.highlightConfig ?? new FlaskCharmHighlightConfig(true);
//     if (init) Object.assign(this, init);
//   }

//   show = true;
//   charmTypes = ['All'];
//   rarity = Rarity.Normal;

//   itemLevel?: number = undefined;
//   quality?: number = undefined;

//   highlightConfig = new FlaskCharmHighlightConfig();
// }

export class FlaskFilter extends AdvancedEquipmentConditions {
  constructor(init?: Partial<FlaskFilter>) {
    super('flask', init);
    this.highlightConfig = init?.highlightConfig ?? new FlaskCharmHighlightConfig();
    if (init) Object.assign(this, init);
  }

  show = true;
  flaskClass = 'Life Flasks';
  flaskBaseTypes = ['All'];
  rarity = Rarity.Normal;

  itemLevel?: number = undefined;
  quality?: number = undefined;

  highlightConfig = new FlaskCharmHighlightConfig();
}

export class JewelFilter extends AdvancedEquipmentConditions {
  constructor(init?: Partial<JewelFilter>) {
    super('jewel', init);
    this.highlightConfig = init?.highlightConfig ?? new JewelHighlightConfig();
    if (init) Object.assign(this, init);
  }

  show = true;
  jewelType = poe1 ? [JewelType.Crimson] : [JewelType.Emerald];
  rarity = Rarity.Magic;

  itemLevel?: number = undefined;

  highlightConfig = new JewelHighlightConfig();
}

export class JewelleryFilter extends AdvancedEquipmentConditions {
  constructor(init?: Partial<JewelleryFilter>) {
    super('jewellery', init);
    this.highlightConfig = init?.highlightConfig ?? new JewelleryHighlightConfig();
    if (init) Object.assign(this, init);
  }

  show = true;
  jewelleryType = JewelleryType.Amulets;
  jewelleryBaseTypes = ['All'];
  rarity = Rarity.Normal;

  unidentifiedTier?: number = undefined; // POE2
  itemLevel?: number = undefined;

  highlightConfig = new JewelleryHighlightConfig();
}

export class WeaponFilter extends AdvancedEquipmentConditions {
  constructor(init?: Partial<WeaponFilter>) {
    super('gear', init);
    this.highlightConfig = init?.highlightConfig ?? new GearHighlightConfig();
    if (init) Object.assign(this, init);
  }

  show = true;
  weaponType = [WeaponType.Bows];
  baseTypeMode = GearBaseTypeMode.Tier;
  baseTypeTier = BaseTypeTier.Expert;
  specificBaseTypes: string[] = ['All'];
  rarity = Rarity.Normal;

  unidentifiedTier?: number = undefined; // POE2
  minLinks?: number = undefined; // POE1

  itemLevel?: number = undefined;

  highlightConfig = new GearHighlightConfig();
}

export class ArmourFilter extends AdvancedEquipmentConditions {
  constructor(init?: Partial<ArmourFilter>) {
    super('gear', init);
    this.highlightConfig = init?.highlightConfig ?? new GearHighlightConfig();
    if (init) Object.assign(this, init);
  }

  show = true;
  armourType = [ArmourType.BodyArmours, ArmourType.Helmets, ArmourType.Gloves, ArmourType.Boots];
  defenceType = [DefenceType.Armour];
  baseTypeMode = GearBaseTypeMode.Tier;
  baseTypeTier = BaseTypeTier.Expert;
  specificBaseTypes: string[] = ['All'];
  rarity = Rarity.Normal;

  minLinks?: number = undefined; // POE1
  unidentifiedTier?: number = undefined; // POE2

  itemLevel?: number = undefined;

  highlightConfig = new GearHighlightConfig();
}

export class IdentifiedItemConfig {
  constructor(init?: Partial<IdentifiedItemConfig>) {
    if (init) Object.assign(this, init);
  }

  enabled = true;
  default = false;

  name?: string;
  type: IdentifiedItemConfigType = IdentifiedItemConfigType.Equipment;
  itemTier: ItemTier = ItemTier.Good;

  rarityComparator: Comparator = Comparator.GreaterThanOrEqual;
  rarity: Rarity = Rarity.Magic;

  allowCorrupted?: boolean;
  minILevel?: number;

  minGearTier?: BaseTypeTier = BaseTypeTier.Expert;
  specificBaseTypes?: string[];

  minPerfectPrefixes?: number;
  minPerfectSuffixes?: number;

  minGreatPrefixes?: number;
  minGreatSuffixes?: number;

  minPerfectMods?: number;
  minGreatMods?: number;
  minGoodMods?: number = 1;

  maxBadMods?: number;
}

export enum IdentifiedItemConfigType {
  Equipment = 'Equipment',
  Jewels = 'Jewels',
}

export enum ItemTier {
  Excellent = 'Excellent',
  Good = 'Good',
}

export type Presets = 'presetEarlyCampaign1' | 'presetMidCampaign30' | 'presetLateCampaignEarlyMaps60' | 'presetMidMaps70' | 'presetEndGame80' | 'presetStrict90' | 'presetVeryStrict95';
export type FilterPreset = Partial<Filter>;

export type Influence = 'Shaper' | 'Elder' | 'Crusader' | 'Hunter' | 'Redeemer' | 'Warlord';

export function createDefaultIdentifiedItemConfigs() {
  return [
    new IdentifiedItemConfig({
      name: 'Excellent Rare Equipment',
      type: IdentifiedItemConfigType.Equipment,
      minGearTier: BaseTypeTier.Expert,
      itemTier: ItemTier.Excellent,
      rarityComparator: Comparator.Equal,
      rarity: Rarity.Rare,
      default: true,
      minGreatPrefixes: 1,
      minGreatSuffixes: 1,
      minGreatMods: undefined,
      minGoodMods: 4,
      maxBadMods: 0,
    }),
    new IdentifiedItemConfig({
      name: 'Good Rare Equipment',
      type: IdentifiedItemConfigType.Equipment,
      minGearTier: BaseTypeTier.Expert,
      itemTier: ItemTier.Good,
      rarityComparator: Comparator.Equal,
      rarity: Rarity.Rare,
      default: true,
      minGreatMods: 1,
      minGoodMods: 3,
      maxBadMods: 1,
    }),
    new IdentifiedItemConfig({
      name: 'Excellent Magic Equipment',
      type: IdentifiedItemConfigType.Equipment,
      minGearTier: BaseTypeTier.Expert,
      itemTier: ItemTier.Excellent,
      rarityComparator: Comparator.Equal,
      rarity: Rarity.Magic,
      default: true,
      minPerfectMods: 1,
      minGoodMods: undefined,
    }),
    new IdentifiedItemConfig({
      name: 'Good Magic Equipment',
      type: IdentifiedItemConfigType.Equipment,
      minGearTier: BaseTypeTier.Expert,
      itemTier: ItemTier.Good,
      rarityComparator: Comparator.Equal,
      rarity: Rarity.Magic,
      default: true,
      minGreatMods: 1,
      minGoodMods: undefined,
    }),
    new IdentifiedItemConfig({
      name: 'Excellent Rare Jewels',
      type: IdentifiedItemConfigType.Jewels,
      itemTier: ItemTier.Excellent,
      rarityComparator: Comparator.Equal,
      rarity: Rarity.Rare,
      default: true,
      minGreatMods: 2,
      minGoodMods: 3,
      maxBadMods: 0,
    }),
    new IdentifiedItemConfig({
      name: 'Good Rare Jewels',
      type: IdentifiedItemConfigType.Jewels,
      itemTier: ItemTier.Good,
      rarityComparator: Comparator.Equal,
      rarity: Rarity.Rare,
      default: true,
      minGreatMods: 1,
      minGoodMods: 2,
    }),
    new IdentifiedItemConfig({
      name: 'Excellent Magic Jewels',
      type: IdentifiedItemConfigType.Jewels,
      itemTier: ItemTier.Excellent,
      rarityComparator: Comparator.Equal,
      rarity: Rarity.Magic,
      default: true,
      minGreatMods: 1,
      minGoodMods: 2,
    }),
    new IdentifiedItemConfig({
      name: 'Good Magic Jewels',
      type: IdentifiedItemConfigType.Jewels,
      itemTier: ItemTier.Good,
      rarityComparator: Comparator.Equal,
      rarity: Rarity.Magic,
      default: true,
      minGreatMods: 1,
      minGoodMods: undefined,
    }),
  ];
}

export function createDefaultExcellentUniquesTier() {
  const excellentUniquesTier = new TierCosmetic();
  excellentUniquesTier.order = 0;
  excellentUniquesTier.name = 'Excellent';
  excellentUniquesTier.uniqueTier = 'Excellent';
  excellentUniquesTier.displayOptions.cosmeticOptions!.highlight = true;
  excellentUniquesTier.displayOptions.cosmeticOptions!.beam = true;
  excellentUniquesTier.displayOptions.cosmeticOptions!.highlightColor = Color.Brown;
  excellentUniquesTier.displayOptions.cosmeticOptions!.minimapIconSize = MinimapIconSize.Large;
  excellentUniquesTier.displayOptions.cosmeticOptions!.minimapIconShape = MinimapIconShape.Kite;
  excellentUniquesTier.displayOptions.cosmeticOptions!.alertSound = true;
  excellentUniquesTier.displayOptions.cosmeticOptions!.alertSoundSound = '6';
  excellentUniquesTier.displayOptions.cosmeticOptions!.alertSoundVolume = 300;
  return excellentUniquesTier;
}

export function createDefaultGoodUniquesTier() {
  const goodUniquesTier = new TierCosmetic();
  goodUniquesTier.order = 1;
  goodUniquesTier.name = 'Good';
  goodUniquesTier.uniqueTier = 'Good';
  goodUniquesTier.displayOptions.cosmeticOptions!.highlight = true;
  goodUniquesTier.displayOptions.cosmeticOptions!.beam = true;
  goodUniquesTier.displayOptions.cosmeticOptions!.highlightColor = Color.Brown;
  goodUniquesTier.displayOptions.cosmeticOptions!.minimapIconSize = MinimapIconSize.Medium;
  goodUniquesTier.displayOptions.cosmeticOptions!.minimapIconShape = MinimapIconShape.Kite;
  goodUniquesTier.displayOptions.cosmeticOptions!.alertSound = true;
  goodUniquesTier.displayOptions.cosmeticOptions!.alertSoundSound = '2';
  goodUniquesTier.displayOptions.cosmeticOptions!.alertSoundVolume = 200;
  return goodUniquesTier;
}

export function createDefaultPotentialUniquesTier() {
  const potentialUniquesTier = new TierCosmetic();
  potentialUniquesTier.order = 2;
  potentialUniquesTier.name = 'Potential';
  potentialUniquesTier.uniqueTier = 'Potential';
  potentialUniquesTier.displayOptions.cosmeticOptions!.highlight = true;
  potentialUniquesTier.displayOptions.cosmeticOptions!.beam = true;
  potentialUniquesTier.displayOptions.cosmeticOptions!.highlightColor = Color.Brown;
  potentialUniquesTier.displayOptions.cosmeticOptions!.minimapIconSize = MinimapIconSize.Small;
  potentialUniquesTier.displayOptions.cosmeticOptions!.minimapIconShape = MinimapIconShape.Kite;
  return potentialUniquesTier;
}

export function createDefaultRestrictedUniquesTier() {
  const restrictedUniquesTier = new TierCosmetic();
  restrictedUniquesTier.order = 3;
  restrictedUniquesTier.name = 'Restricted';
  restrictedUniquesTier.uniqueTier = 'Restricted';
  restrictedUniquesTier.displayOptions.cosmeticOptions!.highlight = true;
  restrictedUniquesTier.displayOptions.cosmeticOptions!.beam = true;
  restrictedUniquesTier.displayOptions.cosmeticOptions!.highlightColor = Color.Brown;
  restrictedUniquesTier.displayOptions.cosmeticOptions!.minimapIconSize = MinimapIconSize.Small;
  restrictedUniquesTier.displayOptions.cosmeticOptions!.minimapIconShape = MinimapIconShape.Kite;
  return restrictedUniquesTier;
}

export function createDefaultOtherUniquesTier() {
  const otherUniquesTier = new TierCosmetic();
  otherUniquesTier.order = 4;
  otherUniquesTier.name = 'Other';
  otherUniquesTier.uniqueTier = 'Other';
  otherUniquesTier.displayOptions.active = false;
  otherUniquesTier.displayOptions.cosmeticOptions!.highlight = true;
  otherUniquesTier.displayOptions.cosmeticOptions!.beam = true;
  otherUniquesTier.displayOptions.cosmeticOptions!.highlightColor = Color.Brown;
  otherUniquesTier.displayOptions.cosmeticOptions!.minimapIconSize = MinimapIconSize.Small;
  otherUniquesTier.displayOptions.cosmeticOptions!.minimapIconShape = MinimapIconShape.Kite;
  return otherUniquesTier;
}

export function createDefaultSearchingChanceBasesTier() {
  const searchingChanceBasesTier = new TierCosmetic();
  searchingChanceBasesTier.order = 0;
  searchingChanceBasesTier.name = 'Searching';
  searchingChanceBasesTier.chanceBaseTier = 'Searching';
  searchingChanceBasesTier.displayOptions.cosmeticOptions!.highlight = true;
  searchingChanceBasesTier.displayOptions.cosmeticOptions!.beam = true;
  searchingChanceBasesTier.displayOptions.cosmeticOptions!.highlightColor = Color.Brown;
  searchingChanceBasesTier.displayOptions.cosmeticOptions!.minimapIconSize = MinimapIconSize.Small;
  searchingChanceBasesTier.displayOptions.cosmeticOptions!.minimapIconShape = MinimapIconShape.Kite;
  return searchingChanceBasesTier;
}

export function createDefaultPotentialChanceBasesTier() {
  const potentialChanceBasesTier = new TierCosmetic();
  potentialChanceBasesTier.order = 1;
  potentialChanceBasesTier.name = 'Potential';
  potentialChanceBasesTier.chanceBaseTier = 'Potential';
  potentialChanceBasesTier.displayOptions.active = false;
  potentialChanceBasesTier.displayOptions.cosmeticOptions!.highlight = true;
  potentialChanceBasesTier.displayOptions.cosmeticOptions!.beam = true;
  potentialChanceBasesTier.displayOptions.cosmeticOptions!.highlightColor = Color.Brown;
  potentialChanceBasesTier.displayOptions.cosmeticOptions!.temp = true;
  potentialChanceBasesTier.displayOptions.cosmeticOptions!.minimapIconSize = MinimapIconSize.Small;
  potentialChanceBasesTier.displayOptions.cosmeticOptions!.minimapIconShape = MinimapIconShape.Kite;
  return potentialChanceBasesTier;
}

export function createDefaultSTier() {
  const sTier = new TierCosmetic();
  sTier.order = 0;
  sTier.tier = Tier.SPurple;
  sTier.name = 'S-Tier';
  sTier.displayOptions.cosmeticOptions!.highlight = true;
  sTier.displayOptions.cosmeticOptions!.beam = true;
  sTier.displayOptions.cosmeticOptions!.highlightColor = Color.Purple;
  sTier.displayOptions.cosmeticOptions!.minimapIconSize = MinimapIconSize.Large;
  sTier.displayOptions.cosmeticOptions!.minimapIconShape = MinimapIconShape.Circle;
  sTier.displayOptions.cosmeticOptions!.alertSound = true;
  sTier.displayOptions.cosmeticOptions!.alertSoundSound = '6';
  sTier.displayOptions.cosmeticOptions!.alertSoundVolume = 300;
  return sTier;
}

export function createDefaultATier() {
  const aTier = new TierCosmetic();
  aTier.order = 1;
  aTier.tier = Tier.ARed;
  aTier.name = 'A-Tier';
  aTier.displayOptions.cosmeticOptions!.highlight = true;
  aTier.displayOptions.cosmeticOptions!.beam = true;
  aTier.displayOptions.cosmeticOptions!.highlightColor = Color.Red;
  aTier.displayOptions.cosmeticOptions!.minimapIconSize = MinimapIconSize.Medium;
  aTier.displayOptions.cosmeticOptions!.minimapIconShape = MinimapIconShape.Circle;
  aTier.displayOptions.cosmeticOptions!.alertSound = true;
  aTier.displayOptions.cosmeticOptions!.alertSoundSound = '6';
  aTier.displayOptions.cosmeticOptions!.alertSoundVolume = 300;
  return aTier;
}

export function createDefaultBTier() {
  const bTier = new TierCosmetic();
  bTier.order = 2;
  bTier.tier = Tier.BOrange;
  bTier.name = 'B-Tier';
  bTier.displayOptions.cosmeticOptions!.highlight = true;
  bTier.displayOptions.cosmeticOptions!.beam = true;
  bTier.displayOptions.cosmeticOptions!.highlightColor = Color.Orange;
  bTier.displayOptions.cosmeticOptions!.minimapIconSize = MinimapIconSize.Small;
  bTier.displayOptions.cosmeticOptions!.minimapIconShape = MinimapIconShape.Circle;
  bTier.displayOptions.cosmeticOptions!.alertSound = true;
  bTier.displayOptions.cosmeticOptions!.alertSoundSound = '2';
  bTier.displayOptions.cosmeticOptions!.alertSoundVolume = 200;
  return bTier;
}

export function createDefaultCTier() {
  const cTier = new TierCosmetic();
  cTier.order = 3;
  cTier.tier = Tier.CYellow;
  cTier.name = 'C-Tier';
  cTier.displayOptions.cosmeticOptions!.highlight = true;
  cTier.displayOptions.cosmeticOptions!.beam = true;
  cTier.displayOptions.cosmeticOptions!.highlightColor = Color.Yellow;
  cTier.displayOptions.cosmeticOptions!.minimapIconSize = MinimapIconSize.Small;
  cTier.displayOptions.cosmeticOptions!.minimapIconShape = MinimapIconShape.Circle;
  cTier.displayOptions.cosmeticOptions!.alertSound = true;
  cTier.displayOptions.cosmeticOptions!.alertSoundSound = '2';
  cTier.displayOptions.cosmeticOptions!.alertSoundVolume = 200;
  return cTier;
}

export function createDefaultDTier() {
  const dTier = new TierCosmetic();
  dTier.order = 4;
  dTier.tier = Tier.DWhite;
  dTier.name = 'D-Tier';
  dTier.displayOptions.cosmeticOptions!.highlight = true;
  dTier.displayOptions.cosmeticOptions!.beam = true;
  dTier.displayOptions.cosmeticOptions!.highlightColor = Color.White;
  dTier.displayOptions.cosmeticOptions!.minimapIconSize = MinimapIconSize.Small;
  dTier.displayOptions.cosmeticOptions!.minimapIconShape = MinimapIconShape.Circle;
  return dTier;
}

export function createDefaultETier() {
  const eTier = new TierCosmetic();
  eTier.order = 5;
  eTier.tier = Tier.EVisible;
  eTier.name = 'E-Tier';
  return eTier;
}

export function createDefaultFTier() {
  const fTier = new TierCosmetic();
  fTier.order = 6;
  fTier.tier = Tier.FHidden;
  fTier.displayOptions.hidden = true;
  fTier.name = 'F-Tier';
  return fTier;
}

export function createDefaultTierCosmetics() {
  const defaultTierCosmetics: TierCosmetic[] = [];

  defaultTierCosmetics.push(createDefaultSTier());
  defaultTierCosmetics.push(createDefaultATier());
  defaultTierCosmetics.push(createDefaultBTier());
  defaultTierCosmetics.push(createDefaultCTier());
  defaultTierCosmetics.push(createDefaultDTier());
  defaultTierCosmetics.push(createDefaultETier());
  defaultTierCosmetics.push(createDefaultFTier());

  return defaultTierCosmetics;
}

export function createDefaultUniqueTierCosmetics(includeRestricted = true) {
  const defaultUniqueTierCosmetics: TierCosmetic[] = [];

  defaultUniqueTierCosmetics.push(createDefaultExcellentUniquesTier());
  defaultUniqueTierCosmetics.push(createDefaultGoodUniquesTier());
  defaultUniqueTierCosmetics.push(createDefaultPotentialUniquesTier());
  if (includeRestricted) {
    defaultUniqueTierCosmetics.push(createDefaultRestrictedUniquesTier());
  }
  defaultUniqueTierCosmetics.push(createDefaultOtherUniquesTier());

  return defaultUniqueTierCosmetics;
}

export function createDefaultChanceBaseTierCosmetics() {
  const defaultChanceBaseTierCosmetics: TierCosmetic[] = [];

  defaultChanceBaseTierCosmetics.push(createDefaultSearchingChanceBasesTier());
  defaultChanceBaseTierCosmetics.push(createDefaultPotentialChanceBasesTier());

  return defaultChanceBaseTierCosmetics;
}

export function createDefaultEquipmentTierCosmetics() {
  const baseTierCosmetics = createDefaultTierCosmetics();
  const equipmentTierCosmetics: TierCosmetic[] = [];

  baseTierCosmetics.forEach(baseTier => {
    // Skip F tier for equipment
    if (baseTier.tier === Tier.FHidden) {
      return;
    }

    const equipmentTier = new TierCosmetic();
    equipmentTier.order = baseTier.order;
    equipmentTier.tier = baseTier.tier;
    equipmentTier.name = baseTier.name;

    const baseOptions = baseTier.displayOptions.cosmeticOptions;
    const equipOptions = equipmentTier.displayOptions.cosmeticOptions!;

    // Copy only highlight-related settings, NOT label settings
    if (baseOptions) {
      equipOptions.highlight = baseOptions.highlight;
      equipOptions.highlightColor = baseOptions.highlightColor;
      equipOptions.beam = baseOptions.beam;
      equipOptions.temp = baseOptions.temp;
      equipOptions.minimapIconSize = baseOptions.minimapIconSize;
      equipOptions.minimapIconShape = MinimapIconShape.Kite;
      equipOptions.alertSound = baseOptions.alertSound;
      equipOptions.alertSoundSound = baseOptions.alertSoundSound;
      equipOptions.alertSoundVolume = baseOptions.alertSoundVolume;
      equipOptions.disableDropSound = baseOptions.disableDropSound;
      equipOptions.customAlertSound = baseOptions.customAlertSound;
    }

    equipmentTierCosmetics.push(equipmentTier);
  });

  return equipmentTierCosmetics;
}

export function createDefaultCustomTierValueList(): TierValueList {
  return poe1 ? [
    { tier: Tier.SPurple, value: 2, baseCurrency: 'Divine Orb' },
    { tier: Tier.ARed, value: 0.5, baseCurrency: 'Divine Orb' },
    { tier: Tier.BOrange, value: 0.2, baseCurrency: 'Divine Orb' },
    { tier: Tier.CYellow, value: 0.05, baseCurrency: 'Divine Orb' },
    { tier: Tier.DWhite, value: 0.02, baseCurrency: 'Divine Orb' },
    { tier: Tier.EVisible, value: 0.01, baseCurrency: 'Divine Orb' },
    { tier: Tier.FHidden, value: 0, baseCurrency: 'Chaos Orb' }
  ] : [
    { tier: Tier.SPurple, value: 10, baseCurrency: 'Divine Orb' },
    { tier: Tier.ARed, value: 3, baseCurrency: 'Divine Orb' },
    { tier: Tier.BOrange, value: 1, baseCurrency: 'Divine Orb' },
    { tier: Tier.CYellow, value: 2, baseCurrency: 'Chaos Orb' },
    { tier: Tier.DWhite, value: 0.5, baseCurrency: 'Chaos Orb' },
    { tier: Tier.EVisible, value: 0.1, baseCurrency: 'Chaos Orb' },
    { tier: Tier.FHidden, value: 0, baseCurrency: 'Chaos Orb' }
  ]
}

export function createDefaultCustomUniquesTierValueList(): UniquesTierValueList {
  return [
    { tier: 'Excellent', value: 5, baseCurrency: 'Divine Orb' },
    { tier: 'Good', value: 0.5, baseCurrency: 'Divine Orb' },
    { tier: 'Other', value: 0, baseCurrency: 'Exalted Orb' }
  ]
}

export function createDefaultCustomClusterJewelTierValueList(): ClusterJewelTierValueList {
  return [
    { tier: 'Excellent', value: 250, baseCurrency: 'Chaos Orb' },
    { tier: 'Good', value: 100, baseCurrency: 'Chaos Orb' },
    { tier: 'Other', value: 0, baseCurrency: 'Chaos Orb' }
  ]
}

export function createDefaultCustomRuleStyles(): CustomRuleStyle[] {
  return [
    {
      ruleId: 'uniques-exceptional',
      custom: false,
      partial: false,
      options: {
        highlight: true,
        beam: true,
        alertSound: true,
        alertSoundSound: '2',
        highlightColor: Color.Brown,
        minimapIconSize: MinimapIconSize.Small,
        minimapIconShape: MinimapIconShape.Kite,
      }
    },
    {
      ruleId: 'uniques-small',
      custom: false,
      partial: false,
      options: {
        highlight: true,
        beam: true,
        alertSound: true,
        alertSoundSound: '2',
        highlightColor: Color.White,
        minimapIconSize: MinimapIconSize.Small,
        minimapIconShape: MinimapIconShape.Circle,
      }
    },
    {
      ruleId: 'uniques-foulborn',
      custom: false,
      partial: false,
      options: {
        highlight: true,
        beam: true,
        alertSound: true,
        alertSoundSound: '2',
        highlightColor: Color.Purple,
        minimapIconSize: MinimapIconSize.Small,
        minimapIconShape: MinimapIconShape.Kite,
      }
    },
    {
      ruleId: 'uniques-high-dust',
      custom: false,
      partial: false,
      options: {
        highlight: true,
        beam: true,
        alertSound: true,
        alertSoundSound: '2',
        highlightColor: Color.Blue,
        minimapIconSize: MinimapIconSize.Small,
        minimapIconShape: MinimapIconShape.Kite,
      }
    },
    {
      ruleId: 'uniques-maps',
      custom: false,
      partial: false,
      options: {
        highlight: true,
        beam: true,
        alertSound: true,
        alertSoundSound: '2',
        highlightColor: Color.Brown,
        minimapIconSize: MinimapIconSize.Small,
        minimapIconShape: MinimapIconShape.Diamond,
      }
    },
    {
      ruleId: 'uniques-vaal',
      custom: false,
      partial: false,
      options: {
        highlight: true,
        beam: true,
        alertSound: true,
        alertSoundSound: '2',
        highlightColor: Color.Red,
        minimapIconSize: MinimapIconSize.Small,
        minimapIconShape: MinimapIconShape.Kite,
      }
    },
    {
      ruleId: 'uniques-vaal-mod',
      custom: false,
      partial: false,
      options: {
        highlight: true,
        beam: true,
        alertSound: true,
        alertSoundSound: '2',
        highlightColor: Color.Red,
        minimapIconSize: MinimapIconSize.Small,
        minimapIconShape: MinimapIconShape.Kite,
      }
    },
    {
      ruleId: 'uniques-raven-touched',
      custom: false,
      partial: false,
      options: {
        highlight: true,
        beam: true,
        alertSound: true,
        alertSoundSound: '2',
        highlightColor: Color.Grey,
        minimapIconSize: MinimapIconSize.Small,
        minimapIconShape: MinimapIconShape.Kite,
      }
    },
    // {
    //   ruleId: 'uniques-class-specific',
    //   options: {
    //     highlight: true,
    //     beam: true,
    //     alertSound: true,
    //     alertSoundSound: '2',
    //     highlightColor: Color.Brown,
    //     minimapIconSize: MinimapIconSize.Small,
    //     minimapIconShape: MinimapIconShape.Kite,
    //   }
    // },
    {
      ruleId: 'quest-items',
      custom: false,
      partial: false,
      options: {
        highlight: true,
        highlightColor: Color.Green,
        beam: true,
        minimapIconShape: MinimapIconShape.Kite,
        minimapIconSize: MinimapIconSize.Small,
        alertSound: true,
        alertSoundSound: '2',
        alertSoundVolume: 200
      }
    },
    {
      ruleId: 'gear-hidden-vendoring-rares',
      custom: false,
      partial: false,
      options: {
        textColor: poe1 ? 'rgba(255,255,119,0.6)' : 'rgba(254,224,85,0.6)',
        backgroundColor: 'rgba(0, 0, 0, 0.6)'
      }
    },
    {
      ruleId: 'gear-hidden-vendoring-magic',
      custom: false,
      partial: false,
      options: {
        textColor: poe1 ? 'rgba(136,136,255,0.6)' : 'rgba(122,151,254,0.6)',
        backgroundColor: 'rgba(0, 0, 0, 0.6)'
      }
    },
    {
      ruleId: 'trial-gold-key',
      custom: false,
      partial: false,
      options: {
        highlight: true,
        beam: true,
        alertSound: true,
        alertSoundSound: '2',
        highlightColor: Color.Orange,
        minimapIconSize: MinimapIconSize.Small,
        minimapIconShape: MinimapIconShape.Kite,
      }
    },
    {
      ruleId: 'trial-silver-key',
      custom: false,
      partial: false,
      options: {
        highlight: true,
        beam: true,
        alertSound: true,
        alertSoundSound: '2',
        highlightColor: Color.Yellow,
        minimapIconSize: MinimapIconSize.Small,
        minimapIconShape: MinimapIconShape.Kite,
      }
    },
    {
      ruleId: 'trial-bronze-key',
      custom: false,
      partial: false,
      options: {
        highlight: true,
        beam: true,
        highlightColor: Color.White,
        minimapIconSize: MinimapIconSize.Small,
        minimapIconShape: MinimapIconShape.Kite,
      }
    }
  ];
}
